import { useMutation } from '@tanstack/react-query';

import { requestCode } from 'apps/customer/state/user';

import type { UseMutationOptions } from '@tanstack/react-query';

export type RequestVerifyCodeVariables = {
  hcaptchaToken?: string;
  phoneNumber: string;
};

function getRequestVerifyCodeErrorMessage(error?: string) {
  if (error?.includes('HCAPTCHA_REQUIRED')) {
    return 'Please complete the human verification to continue.';
  }
  if (error?.includes('HCAPTCHA_VERIFICATION_FAILED')) {
    return 'Human verification failed. Please check the box again.';
  }
  if (
    error?.includes('HCAPTCHA_SERVICE_UNAVAILABLE') ||
    error?.includes('HCAPTCHA_MISCONFIGURED')
  ) {
    return 'Verification is temporarily unavailable. Please try again shortly.';
  }

  return 'Phone number verification failed. Please try again.';
}

export function useRequestVerifyCode(
  options?: UseMutationOptions<void, Error, RequestVerifyCodeVariables>,
) {
  return useMutation({
    mutationFn: async ({ hcaptchaToken, phoneNumber }: RequestVerifyCodeVariables) => {
      const response = await requestCode({ hcaptchaToken, phoneNumber });

      if (!response.success) {
        throw new Error(getRequestVerifyCodeErrorMessage(response.error));
      }
    },
    ...options,
  });
}
